module.exports = __webpack_public_path__ + "static/11-Synpatics-49053b6b19d50b8f6e123b365fcf93cb.png";